import { useState, useEffect } from 'react'
import { gql, useQuery } from '@apollo/client'
import { ICustomerPVAtoms } from '../store/CustomerPVAtom'
import { ICustomerLoadAtoms } from '../store/CustomerLoadAtom'
import { IPurchasePlansAtoms } from '../store/PurchasePlansAtom'
import { ISellPlansAtoms } from '../store/SellPlansAtom'

export const findAllPVcust = gql`
  query findAllPVcust {
    findAllPVcust {
      _id
      name
    }
  }
`

export const findAllLoadCust = gql`
  query findAllLoadCust {
    findAllLoadCust {
      _id
      name
    }
  }
`

export const findAllSellTOU = gql`
  query findAllSellTOU {
    findAllSellTOU {
      _id
      name
      custId
    }
  }
`

export const findAllBuyTOU = gql`
  query findAllBuyTOU {
    findAllBuyTOU {
      _id
      name
      custId
    }
  }
`
export const useCustomerData = () => {
  const { data: pvCustomers } = useQuery<{
    findAllPVcust: Partial<ICustomerPVAtoms>[]
  }>(findAllPVcust)
  const { data: loadCustomers } = useQuery<{
    findAllLoadCust: Partial<ICustomerLoadAtoms>[]
  }>(findAllLoadCust)
  const { data: buyTOU } = useQuery<{
    findAllBuyTOU: Partial<IPurchasePlansAtoms>[]
  }>(findAllBuyTOU)
  const { data: sellTOU } = useQuery<{
    findAllSellTOU: Partial<ISellPlansAtoms>[]
  }>(findAllSellTOU)

  const [pvCustomerList, setPvCustomerList] = useState<
    Partial<ICustomerPVAtoms>[]
  >([])
  const [loadCustomerList, setLoadCustomerList] = useState<
    Partial<ICustomerLoadAtoms>[]
  >([])
  const [buyTOUList, setBuyTOUList] = useState<Partial<IPurchasePlansAtoms>[]>(
    []
  )
  const [sellTOUList, setSellTOUList] = useState<Partial<ISellPlansAtoms>[]>([])

  useEffect(() => {
    if (pvCustomers) {
      setPvCustomerList(
        pvCustomers.findAllPVcust.map((m) => ({ _id: m._id, name: m.name }))
      )
    }
    if (loadCustomers) {
      setLoadCustomerList(
        loadCustomers.findAllLoadCust.map((m) => ({ _id: m._id, name: m.name }))
      )
    }
    if (buyTOU) {
      setBuyTOUList(
        buyTOU.findAllBuyTOU.map((m) => ({
          _id: m._id,
          name: m.name,
          custId: m.custId,
        }))
      )
    }
    if (sellTOU) {
      setSellTOUList(
        sellTOU.findAllSellTOU.map((m) => ({
          _id: m._id,
          name: m.name,
          custId: m.custId,
        }))
      )
    }
  }, [pvCustomers, loadCustomers, buyTOU, sellTOU])

  return { pvCustomerList, loadCustomerList, buyTOUList, sellTOUList }
}
